  import React, { Component } from "react";
  import { Form, Checkbox } from 'semantic-ui-react'

  export default class CheckBox extends Component {

    render() {
      const value=this.props.value;
      const label = this.props.label;
      return (
          <Form.Field>
          <label  style={{color: this.props.darkmode ? "white": "black"}}>{this.props.field.label}</label>
          <Checkbox  checked={value} onChange={this.props.onChange} disabled={!this.props.enabled}/>
          </Form.Field>
      );
    }
  }